// Only bounded codes leave report preparation or server error JSON. Never expose
// raw exception messages, response details, credentials, URLs, or report data.
const codes = new Set(['timeout', 'config', 'report', 'auth', 'render', 'cancelled', 'unauthorized', 'forbidden', 'not-found', 'conflict', 'busy', 'unavailable', 'gateway-timeout'])
export function bulkPdfErrorCode(error, fallback = 'render') {
  if (error?.response?.status === 401 || error?.response?.status === 403 || error?.code === 'auth' || /权限|permission/i.test(String(error?.message || ''))) return 'auth'
  if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') return 'timeout'
  return codes.has(error?.code) ? error.code : codes.has(fallback) ? fallback : 'render'
}
export function bulkPdfError(code) {
  const safeCode = bulkPdfErrorCode({ code })
  return Object.assign(new Error(safeCode), { code: safeCode })
}

export async function serverPdfError(error) {
  if (error?.code === 'ERR_CANCELED' || error?.name === 'AbortError') return bulkPdfError('cancelled')
  const status = error?.response?.status
  const statusCode = { 401: 'unauthorized', 403: 'forbidden', 404: 'not-found', 409: 'conflict', 429: 'busy', 503: 'unavailable', 504: 'gateway-timeout' }[status]
  let code = statusCode || bulkPdfErrorCode(error, 'render')
  // Axios returns error JSON as a Blob when responseType is blob. Parse only
  // bounded small JSON and accept our vocabulary, never arbitrary server text.
  const body = error?.response?.data
  try {
    const json = body instanceof Blob && body.size <= 16384 ? JSON.parse(await body.text()) : body
    const candidate = json?.code || (typeof json?.detail === 'object' ? json.detail?.code : undefined)
    if (!statusCode && codes.has(candidate)) code = candidate
  } catch { /* Non-JSON/HTML gateway errors still use the safe HTTP category. */ }
  const result = bulkPdfError(code)
  const retry = error?.response?.headers?.['retry-after']
  if (typeof retry === 'string' || typeof retry === 'number') {
    const seconds = /^\d+$/.test(String(retry)) ? Number(retry) : Math.ceil((Date.parse(retry) - Date.now()) / 1000)
    if (Number.isFinite(seconds) && seconds > 0) result.retryAfter = Math.min(3600, seconds)
  }
  return result
}
